import React, { useEffect, useRef, useState } from 'react';
import './content-manager.styles.scss';
import SearchBar from '../search-bar/search-bar.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate, faShoppingCart, faUpload } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import ResultsContainer from './results-container.component';
import { getMyContentFromDb, getPackageFromDb } from '@/utils/getDataFromDb';
import { useSelector } from 'react-redux';
import { get, off } from 'firebase/database';

const ContentManager = ({
    element, 
    chooseElement,
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ path, setPath ] = useState(null);
    const [ cat, setCat ] = useState();
    const [ dir, setDir ] = useState();
    const [ currentContent, setCurrentContent ] = useState([]);
    const [ contentToShow, setContentToShow ] = useState([]);
    const [ showDrop, setShowDrop ] = useState(false);
    const [ freeContent, setFreeContent ] = useState([]);
    const [ uploadedContent, setUploadedContent ] = useState(null);
    const [ searchText, setSearchText ] = useState(null);
    const contentRef = useRef({});
    const location = useLocation();
    const navigate = useNavigate();
    let contentListener;

    useEffect(() => {

        return () => {
            if (contentListener) off(contentListener);
        }
    }, [])

    useEffect(() => {
        getFreeContent();
        getUploadedContent();
    }, [userProfile])

    useEffect(() => {
        if (!userProfile) return;
        setCat(null);
        setDir(null);
        
        setCurrentContent([]);
        setContentToShow([]);
        if (path === "uploads" && uploadedContent) {
            let content = Object.values(uploadedContent)
            .filter(c => c[path])
            setCurrentContent(content);
            setContentToShow(content);
        } else if (path === "free" && freeContent) {
            setCurrentContent(Object.values(freeContent));
            setContentToShow(Object.values(freeContent));
        }
         
    }, [path, uploadedContent, freeContent, userProfile])

    useEffect(() => {
        if (!cat) {
            setContentToShow([...currentContent]);
        } else {
            setContentToShow(
                currentContent.filter(c => c.cat === cat)
            )
        }
    }, [cat])

    function search(text) {
        setDir(null);
        setCat(null);
        setSearchText(text)
    }

    function getFreeContent() {
        getPackageFromDb({
            "packageId": "FREE",
            "callback": callback,
        })
        function callback(data) {
            let newObj = {};
            for (let item of Object.values(data)) {
                if (item.id === 'FREE') continue;
                item.free = true;
                newObj[item.id] = item;
            }
            contentRef.current = {
                ...contentRef.current,
                ...newObj
            }
            setFreeContent(contentRef.current);
        }
    }

    function getUploadedContent() {
        getMyContentFromDb({
            'appId': userProfile.appId,
            'once': true,
            'callback': callback,
        })
        function callback(data) {
            if (!data) return;
            const newObj = {};
            Object.values(data).forEach(d => {
                d.uploads = true;
                newObj[d.id] = d;
            });
            contentRef.current = {...newObj}
            setUploadedContent(contentRef.current);
        }
    }

    return (
        <div className={`content-manager ${screenSize}`}>
            <div className='left-menu'>
                <button 
                    className={`g-button small-btn ${
                        path === 'uploads'
                        ? 'primary'
                        : ''
                    }`}
                    onClick={() => 
                        (path !== 'uploads') 
                        ? setPath('uploads') 
                        : null
                    }>
                    <FontAwesomeIcon icon={faUpload} />
                    {
                        (screenSize !== 'mobile') && "Your Content"
                    }
                </button>
                <button 
                    className={`g-button small-btn ${
                        path === 'free'
                        ? 'primary'
                        : ''
                    }`}
                    onClick={() => 
                        (path !== 'free') 
                        ? setPath('free') 
                        : null
                    }>
                    <FontAwesomeIcon icon={faCertificate} />
                    {
                        (screenSize !== 'mobile') && "Free Content"
                    }
                </button>
                <button 
                    className={`g-button small-btn ${
                        path === 'purchases'
                        ? 'primary'
                        : ''
                    }`}
                    onClick={() => 
                        (path !== 'purchases') 
                        ? setPath('purchases') 
                        : null
                    }>
                    <FontAwesomeIcon icon={faShoppingCart} />
                    {
                        (screenSize !== 'mobile') && "Your Purchases"
                    }
                </button>
            </div>
            <div className="content">
                <div className='search-div'>
                    <SearchBar search={search} />
                    {/* <div>
                        <button
                            className={`g-button med-btn ${
                                path !== 'uploads'
                                ? 'disabled'
                                : ''
                            }`}
                            onClick={() => setShowDrop(!showDrop)}>
                            Create ...
                        </button>
                    </div>
                    <div className={`create-dropdown ${showDrop ? 'active' : ''}`}>
                        <div className='create-dropdown-menu'>
                            <button className='g-button text-only create-menu-item'>
                                <FontAwesomeIcon icon={faImage} />
                                Upload Image
                            </button>
                            <button className='g-button text-only create-menu-item'>
                                <FontAwesomeIcon icon={faFolder} />
                                New Directory
                            </button>
                        </div>
                    </div> */}
                </div>
                <div className="g-space-0-5"></div>
                <ResultsContainer
                    contentToShow={contentToShow}
                    path={path}
                    cat={cat}
                    setCat={setCat}
                    dir={dir}
                    setDir={setDir} 
                    searchText={searchText}
                    element={element}
                    chooseElement={chooseElement} />
            </div>
        </div>
    )
}

export default ContentManager